import { useContext, useState } from "react";
import { FRPContext, FRPElement, setShownElementsIds, setView, setFilter } from "./FRPState";
import { FRPFunc } from "./FRPFunc";
import { ViewButtonIcon, TooltipWrapper } from "src/propertyInfoTemplates/PropertyComponents";
import { Localization } from "@viamap/viamap2-common";
import { Eye } from "iconsax-react";


export function FRPProjektView(props: {
   onHover: (id: string[] | null) => void
}) {

   let { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);
   let layers = frpState.shownElementsIds ?? FRPFunc.determineAllRootElements(frpState);
   const filter = FRPFunc.frpHandleFilter(frpState.filter, frpState);
   const filteredElements = Object.values(frpState.elements).filter(e => layers.includes(e.id)).filter(filter);
   const [isEyeActive, setIsEyeActive] = useState(false);


   const tags = new Set(filteredElements.flatMap(element => element.tags).filter(tag => tag !== undefined && tag !== null && tag !== "").filter(tag => frpState.tagOptions.some((t) => t.id === tag)));


   return (
      <div className="FRP_featureCon">
         {/* <div className="FRP_featureHeader"> */}



         <h5 className="FRP_featureTitle">
            {frpState.selectedProject?.name || "Projekt"}
         </h5>
         <h6>{Localization.getText("Status")}</h6>
         <FRPElementStatus onHover={props.onHover} elements={filteredElements} setIsEyeActive={setIsEyeActive} />
         <h6>{Localization.getText("Layer")}</h6>
         <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
            <ViewButtonIcon
               title={Localization.getText("View all layers")}
               onClick={() => {
                  if (isEyeActive) {
                     frpDispatch(setShownElementsIds(FRPFunc.determineAllRootElements(frpState)));
                     frpDispatch(setView('project'));
                     frpDispatch(setFilter({}));
                     setIsEyeActive(false);
                  } else {
                     frpDispatch(setShownElementsIds(Object.values(frpState.elements).map(element => element.id)));
                     frpDispatch(setView('project'));
                     frpDispatch(setFilter({}));
                     setIsEyeActive(true);
                  }
               }}
               style={{
                  backgroundColor: isEyeActive ? '#4CAF50' : 'white',
                  marginRight: '-40px'
               }}
            >
               <Eye color={isEyeActive ? '#fff' : '#000'} />
            </ViewButtonIcon>

            <FRPElementLayers onHover={props.onHover} setIsEyeActive={setIsEyeActive} />
         </div>
         {/* <h6>Grupper {grupper.size}</h6> */}
         {/* <FRPElementGroups onHover={props.onHover} setFrpFilter={props.setFrpFilter} elements={filteredElements} groups={grupper} /> */}
         <h6>{Localization.getText("Tags")} {tags.size}</h6>
         <FRPElementTags
            onHover={props.onHover}
            elements={filteredElements}
            tags={tags} setIsEyeActive={setIsEyeActive} />
      </div>
   );
}

export function FRPElementStatus({
   elements,
   onHover,
   setIsEyeActive
}: {
   elements: FRPElement[],
   onHover: (id: string[] | null) => void,
   setIsEyeActive: (isEyeActive: boolean) => void
}) {

   const { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);

   // Determine resolved status for each element before grouping (inferred from children)
   const elementsWithResolvedStatus = elements.map(element => {
      const { status: inferredStatus } = FRPFunc.determineNestedChildrenStatusWithSource(element, frpState);
      return {
         ...element,
         resolvedStatus: inferredStatus || ""
      };
   });

   const groupedElements = Object.groupBy(elementsWithResolvedStatus, (element) => element.resolvedStatus) as { [status: string]: FRPElement[] };

   return (
      <div className="FRP_elementStatus">
         {Object.entries(groupedElements).map(([status, elements]: [string, FRPElement[]]) => {
            let foundStatus = frpState.statusOptions.find((a) => a.id === status);
            const elementIds = elements?.map((element) => element.id);

            return (
               <TooltipWrapper key={status} title={
                  <div style={{ textAlign: 'center' }}>
                     <div>{foundStatus?.val || "Unknown"}</div>
                     <div>{elements?.length}</div>
                  </div>
               }>
                  <div
                     key={status}
                     className="FRP_elementStatusItem"
                     onClick={() => {
                        FRPFunc.goToElement(frpState, frpDispatch, elementIds);
                        setIsEyeActive(false);
                     }}
                     onMouseEnter={() => onHover(elementIds ?? null)}
                     onMouseLeave={() => onHover(null)}
                     style={{ flex: elements?.length, backgroundColor: foundStatus?.color || "#eee" }}
                  />
               </TooltipWrapper>
            )
         }) ?? <></>}
      </div>
   );
}


export function FRPElementLayers({
   onHover,
   setIsEyeActive
}: {
   onHover: (id: string[] | null) => void,
   setIsEyeActive: (isEyeActive: boolean) => void
}) {

   const { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);

   const buildLayerHierarchy = (rootIds: string[]): { [layer: number]: string[] } => {
      const hierarchy: { [layer: number]: string[] } = {};
      let currentLayer = 0;
      let currentIds = rootIds;

      while (currentIds.length > 0) {
         hierarchy[currentLayer] = currentIds;
         currentIds = currentIds.flatMap(id => frpState.childrenLookupTable[id] || []);
         currentLayer++;
      }

      return hierarchy;
   };

   const layerHierarchy = buildLayerHierarchy(FRPFunc.determineAllRootElements(frpState));
   return (
      <div className="FRP_elementStatus">

         {Object.entries(layerHierarchy).map(([layer, elementIds]) => {
            const layerNumber = parseInt(layer);
            const elements = elementIds.map(id => frpState.elements[id]).filter(Boolean);

            return (
               <TooltipWrapper key={layerNumber} title={
                  <div style={{ textAlign: 'center' }}>
                     <div>Layer {layerNumber}</div>
                     <div>{elements.length}</div>
                  </div>
               }>
                  <div key={layer} className="FRP_elementStatusItem"
                     onClick={() => {
                        frpDispatch(setView('project'));
                        frpDispatch(setFilter({}));
                        frpDispatch(setShownElementsIds(elementIds));
                        setIsEyeActive(false);
                     }}
                     onMouseEnter={() => onHover(elementIds)}
                     onMouseLeave={() => onHover(null)}
                     style={{
                        flex: elements.length,
                        backgroundColor: `hsl(${layerNumber * 60}, 70%, 70%)`
                     }}>
                  </div>
               </TooltipWrapper>
            );
         })}
      </div>
   );
}

function FRPElementTags({ elements, tags, onHover, setIsEyeActive }: { elements: FRPElement[], tags: Set<string>, onHover: (id: string[] | null) => void, setIsEyeActive: (isEyeActive: boolean) => void }) {
   const { state: frpState, dispatch: frpDispatch } = useContext(FRPContext);

   return (
      <div className="FRP_elementTags">
         {Array.from(tags).map((tag) => {
            const tagElements = elements.filter(element => element.tags?.includes(tag));
            let hoverID = tagElements?.map((element) => element.id); // Ensure elements are processed

            // Get the tag color from frpState.tagOptions
            const currentTag = frpState.tagOptions.find((t) => t.id === tag)

            return (
               <div key={currentTag?.id} onClick={() => {
                  frpDispatch(setView('project'));
                  frpDispatch(setFilter({ tags: [tag] }));
                  setIsEyeActive(false);
               }} className="FRP_elementTag"
                  onMouseEnter={() => onHover(hoverID ?? null)}
                  onMouseLeave={() => onHover(null)}
                  style={{
                     backgroundColor: currentTag?.color + "4a",
                     borderLeft: `4px solid ${currentTag?.color}`,
                     color: "#000"
                  }}
               >
                  {currentTag?.val}<span className="FRP_elementTagCount">{tagElements.length}</span>
               </div>
            );
         })}
      </div>
   );
}

